import styled, { css } from 'styled-components';

import FormatPrice from '@shared/containers/FormatPrice';

const Price = styled(FormatPrice)`
  ${({ theme, discount }) =>
    discount &&
    css`
      margin-right: ${theme.commons.productItemPrice.price.marginRight};
    `}

  ${({ theme, original }) =>
    original &&
    css`
      text-decoration: line-through;
      ${theme.fontFamily.secondaryFont.xSmallRegular};
    `}

  ${({ subsidized, discount }) =>
    subsidized &&
    !discount &&
    css`
      margin-right: 5px;
    `}
`;

export default Price;
